/**
 * TAX permission codes used by the web. Mirrors `definePermissions('tax', …)`
 * in api/src/modules/tax/permissions.ts.
 */
export const P = {
  einvoice: {
    read: 'tax.einvoice.read',
    create: 'tax.einvoice.create',
    post: 'tax.einvoice.post',
    approve: 'tax.einvoice.approve',
    export: 'tax.einvoice.export',
  },
  egs: { read: 'tax.egs.read', onboard: 'tax.egs.onboard' },
  taxCode: { read: 'tax.tax_code.read', configure: 'tax.tax_code.configure' },
  vatReturn: { read: 'tax.vat_return.read', prepare: 'tax.vat_return.prepare', file: 'tax.vat_return.file' },
  purchases: { read: 'tax.purchase_register.read', create: 'tax.purchase_register.create' },
  zakat: { read: 'tax.zakat.read', prepare: 'tax.zakat.prepare', post: 'tax.zakat.post' },
  report: { read: 'tax.report.read' },
  kpi: { read: 'tax.kpi.read' },
  setting: { propose: 'tax.setting.propose', approve: 'core.setting.approve' },
} as const;
